import React from 'react'
import { SvgIcon } from '@material-ui/core'

export default function MkcIcon() {
  return (
    <SvgIcon>
      <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        preserveAspectRatio="xMidYMid meet"
      >
        <g id="layer101" stroke="none">
          <path class="st0" d="M23.98,12.2L23.98,12.2l-0.04-0.05l-0.11-0.13c-3.87-4.44-7.98-6.63-12.21-6.46
	C4.89,5.81,0.33,11.79,0.14,12.04l-0.11,0.15l-0.05,0.05l0.01,0.01l-0.01,0.01l0.19,0.2c4.04,4.18,8.14,6.3,12.22,6.3
	c0.31,0,0.62-0.01,0.94-0.04c6.42-0.51,10.36-6.06,10.52-6.3l0.14-0.21L23.98,12.2z M0.88,12.15c0.92-0.81,4.05-3.31,8.41-4.13
	c-1.22,0.92-2.03,2.43-2.03,4.15c0,1.65,0.74,3.11,1.87,4.03c-2.77-0.6-5.56-1.94-8.3-4.01C0.85,12.19,0.87,12.17,0.88,12.15z
	 M16.71,12.18c0-1.73-0.81-3.25-2.04-4.17c2.62,0.47,5.46,1.71,8.4,4.15c0.03,0.03,0.05,0.05,0.08,0.09
	c-0.68,0.65-2.91,2.58-6.22,3.63c-0.77,0.24-1.56,0.42-2.34,0.53C15.86,15.5,16.71,13.95,16.71,12.18z M11.63,6.21
	c3.01-0.11,5.96,1.04,8.82,3.4C13.31,5.39,7,7.57,3.4,9.68C5.35,8.07,8.21,6.34,11.63,6.21z M13.26,18.07
	c-3.2,0.26-6.43-0.9-9.66-3.39c3.2,1.78,6.15,2.43,8.74,2.43c3.59,0,6.5-1.24,8.49-2.45C19.09,16.17,16.49,17.82,13.26,18.07z"/>
        </g>
      </svg>
    </SvgIcon>
  )
}
